<template>
	<div class="waterfertilizer">
		<div class="waterfertilizer_table_nav">
			<table class="waterfertilizer_table">
				<tr class="waterfertilizer_table_th">
					<th>监测名</th>
					<th>预警下限</th>
					<th>预警上限</th>
					<th>设置</th>
				</tr>
			</table>
		</div>
		<el-scrollbar height="200px">
			<table class="waterfertilizer_el-scrollbar_table">
				<tr v-for="item in tableData" :key="item.id">
					<td>{{item.environmentName}}</td>
					<td>{{item. environmentLowerLimit}}</td>
					<td>{{item.environmentUpperLimit}}</td>
					<td> <el-button :type="item.isEnable==false?'success':'danger'" link
							@click="isEnableClick(item.id,item.environmentName,item.isEnable)">
							{{ item.isEnable==false?'启用':'禁用' }}
						</el-button>

						<el-button type="success" link @click="Updatedialog(item.id,item.environmentName)">
							修改
						</el-button>
					</td>
				</tr>
			</table>
		</el-scrollbar>
	</div>
	<el-dialog v-model="isEnable" :title="environmentName" width="500" align-center>
		<span>确认{{environmentisEnabletext}}</span>
		<template #footer>
			<div class="dialog-footer">
				<el-button @click="isEnable = false">取消</el-button>
				<el-button type="primary" @click="ConfirmisEnable()">
					确认
				</el-button>
			</div>
		</template>
	</el-dialog>

	<el-dialog v-model="updateentity" :title="environmentName" width="500" align-center>
		<el-form :model="form">
			<el-form-item label="预警上限" label-width="80">
				<el-input v-model="form.environmentUpperLimit" autocomplete="off" />
			</el-form-item>
			<el-form-item label="预警下限" label-width="80">
				<el-input v-model="form.environmentLowerLimit" autocomplete="off" />
			</el-form-item>
		</el-form>
		<template #footer>
			<div class="dialog-footer">
				<el-button @click="updateentity = false">取消</el-button>
				<el-button type="primary" @click="ConfirmUpdate()">
					确认
				</el-button>
			</div>
		</template>
	</el-dialog>

</template>

<script setup>
	import {
		ref,
		onMounted,
		reactive
	} from 'vue';
	import {
		IsEnableEnvironment,
		GetEnvironmentalmonitoringtables,
		UpdateEnvironment
	} from '@/api/api.js';
	const tableData = ref()
	//是否打开禁止确认对话框
	let isEnable = ref(false)
	//是否打开修改对话框
	let updateentity = ref(false)
	let id = null;
	let environmentisEnabletext = ref('');
	let environmentisEnable = ref(null);
	let environmentName = ref('');
	let form = ref({
		environmentLowerLimit: null,
		environmentUpperLimit: null

	})

	GetEnvironmentalmonitoringtables().then(res => {
		tableData.value = res.data
		console.log(res,'res')
	}).catch(err => {
		console.log(err)
	})

	function isEnableClick(ids, environmentNames, environmentisEnables) {
		id = ids
		environmentName.value = environmentNames
		environmentisEnable = environmentisEnables
		if (environmentisEnables) {
			environmentisEnabletext.value = '禁用'
		} else {
			environmentisEnabletext.value = '启用'
		}
		isEnable.value = true;
	}

	function ConfirmisEnable() {
		IsEnableEnvironment(id).then(res => {
			GetEnvironmentalmonitoringtables().then(res => {
				tableData.value = res.data
			}).catch(err => {
				console.log(err)
			})
		}).catch(err => {
			console.log(err)
		})
		isEnable.value = false;
	}

	function Updatedialog(ids, environmentNames) {
		id = ids
		environmentName.value = environmentNames
		updateentity.value = true;
	}

	function ConfirmUpdate() {
		UpdateEnvironment(id, form.value).then(res => {
			GetEnvironmentalmonitoringtables().then(res => {
				tableData.value = res.data
			}).catch(err => {
				console.log(err)
			})
		}).catch(err => {
			console.log(err)
		})
		updateentity.value = false;
	}
</script>

<style lang="scss">
	.waterfertilizer {
		.waterfertilizer_table_nav {
			width: 380px;
			margin-left: 10px;
			border-bottom: 1px solid #34e2b7;

			th {
				display: inline-block;
				width: 94px;
				height: 30px;
				line-height: 30px;
			}
		}
	}

	.waterfertilizer .el-scrollbar {
		margin-top: 10px;
		width: 390px;
		margin-left: 10px;

		.el-scrollbar__bar {
			display: block !important;

			.el-scrollbar__thumb {
				opacity: 1;
				background-color: #34e2b7;
			}
		}

		.el-scrollbar__bar.is-vertical {
			height: 265px;
			background-color: #0e584e;
			/* 垂直滚动条背景色设为透明 */
		}
	}

	.waterfertilizer th,
	.waterfertilizer td {
		text-align: center;
		display: inline-block;
		width: 94px;
		height: 30px;
		line-height: 30px;
	}
</style>